import AxiosInstance from "./../api/AxiosInstance.js";
import useAPIList from "../api/useAPIList.js";
import AxiosFileSender from "../lib/AxiosFileSender.js";


export async function fetchExercises(BodypartId){
    return AxiosInstance.get(`/api/resources/exercises/${BodypartId}/exercises`).then(res => res.data);
}

export function useExercises(BodypartId) {
    const [items, add, edit, deleteItem] = useAPIList(`/api/resources/exercises/${BodypartId}/exercises`);
    return [items, add, edit, deleteItem]; // edit is HTTP put with an id, so works as add
} 

export async function SendExercises(pdf, values) {
    return AxiosFileSender.post(`/api/resources/exercises/send`,{params: { pdf, values }}).then(res=>res.data);
}

export async function addResource(values){
    return AxiosFileSender.post(`/api/resources/leaflets`, values).then(res => res.data);
}

export async function fetchResource(resourceId) {
    return AxiosInstance.get(`/api/resources/${resourceId}`).then(res => res.data);
}

export async function fetchResourcesByFilter(filter, startsWith, limit, offset, lang, showAll) {
    return AxiosInstance.get(`/api/resources/leaflets`, {params: { filter, startsWith, limit, offset, lang, showAll }}).then(res => res.data);
}

export function deleteResource( resourceId) {
    return AxiosInstance.delete(`/api/resources/leaflets/${resourceId}`).then(res => res.data)
}

export async function createResource(resourceType, resourceId) {
    return AxiosInstance.post(`/create/resources/`).then(res => res.data);
}

export async function download(resourceType, resourceId) {
    return AxiosInstance.get(`/${resourceId}/download`).then(res => res.data);
}

export async function SendLeaflet(resourceId, values) {
    return AxiosInstance.post(`/api/resources/leaflets/${resourceId}/send`, values).then(res=>res.data);
}

export function asArticle(resource) {
    return {
        id: resource.id,
        title: resource.title,
        thumbnail : resource.Leaflet.preview
    }
}

export function updateResource(resourceType, resourceId, values) {
    return AxiosFileSender.put(`/api/resources/${resourceType}/${resourceId}`, values).then(res => res.data).catch(err => {
        const data = err.response.data;
        const errors = [
            data.inputErrors ? "Erros nos inputs:\n - " + (data.inputErrors || []).join("\n - ") : "",
            data.variableErrors ? "Erros nas variáveis:\n - " + (data.variableErrors || []).join("\n - ") : "",
            data.resultErrors ? "Erros nos resultados:\n - " + (data.resultErrors || []).join("\n - ") : "",
        ].filter(item => item).join("\n");
        if (errors)
            throw errors;
        else throw err;
    })
}